export default __webpack_public_path__ + "static/media/DavidBurckle_ponentes.73d4717e.png";